import React from "react";

import { Icon, IconProps } from "../";

export const RhombusIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M14.7194 7.64835L16.3517 9.28059C17.2973 10.2262 17.5417 10.6675 17.7025 11.1981C17.8633 11.7287 17.8633 12.2713 17.7025 12.8019C17.5417 13.3325 17.2973 13.7738 16.3517 14.7194L14.7194 16.3517C13.7738 17.2973 13.3325 17.5417 12.8019 17.7025C12.2713 17.8633 11.7287 17.8633 11.1981 17.7025C10.6675 17.5417 10.2262 17.2973 9.28059 16.3517L7.64834 14.7194C6.70275 13.7738 6.45831 13.3325 6.29749 12.8019C6.13668 12.2713 6.13668 11.7287 6.29749 11.1981C6.45831 10.6675 6.70275 10.2262 7.64834 9.28059L9.28059 7.64835C10.2262 6.70275 10.6675 6.45831 11.1981 6.29749C11.7287 6.13668 12.2713 6.13668 12.8019 6.29749C13.3325 6.45831 13.7738 6.70275 14.7194 7.64835Z" />
    </Icon>
  );
};
